module.exports = __webpack_public_path__ + "img/review.44f545cb.png";